import React from 'react';
import {
  SkeletonAvatar,
  SkeletonIcon,
  SkeletonLine,
  SkeletonMedia,
  SkeletonPill,
} from '../../Skeleton';
import ChatTargetListRow from './ChatTargetListRow';

const joinClassNames = (...tokens) => tokens.filter(Boolean).join(' ');

const buildPlaceholders = (count) =>
  Array.from({ length: Math.max(1, Number(count) || 0) }, (_, index) => index);

const EVENT_SKELETON_ROW_CLASSES = {
  root: 'event-target-row chat-target-row chat-target-row--event',
  left: 'event-target-row__media chat-target-row__media event-list__flyer-shell',
  center: 'event-target-row__text chat-target-row__text',
  nameLine: 'event-target-row__title-line chat-target-row__title-line',
  name: 'event-list__title chat-target-row__title',
  preview: 'event-list__last-preview chat-target-row__preview',
};

const ChatTargetSidebarLoading = ({
  variant = 'row',
  count = 5,
  className = '',
  itemClassName = '',
  label = '読み込み中…',
  showLoadMore = false,
  loadMoreClassName = '',
  loadMoreButtonClassName = '',
  loadMoreLabel = 'さらに取得',
  animated = false,
}) => {
  const placeholders = buildPlaceholders(count);
  const isEventVariant = variant === 'event';

  return (
    <>
      {placeholders.map((index) => (
        isEventVariant ? (
          <ChatTargetListRow
            key={`${variant}-${index}`}
            classNames={EVENT_SKELETON_ROW_CLASSES}
            className={joinClassNames(
              'chat-target-sidebar-loading',
              'chat-target-sidebar-loading--event',
              animated ? 'chat-target-sidebar-loading--animated' : '',
              itemClassName,
              className
            )}
            ariaHidden
            avatar={(
              <SkeletonMedia
                className="event-list__flyer-placeholder chat-target-row__flyer chat-target-sidebar-loading__eventThumb"
                animated={animated}
              />
            )}
            title={(
              <SkeletonLine
                className="chat-target-sidebar-loading__line chat-target-sidebar-loading__line--title"
                animated={animated}
              />
            )}
            titleExtra={(
              <SkeletonLine
                className="event-list__performance chat-target-sidebar-loading__line chat-target-sidebar-loading__line--performance"
                animated={animated}
              />
            )}
            previewNode={(
              <SkeletonLine
                className="event-list__last-preview chat-target-sidebar-loading__line chat-target-sidebar-loading__line--preview"
                animated={animated}
              />
            )}
            right={(
              <div className="event-target-row__side chat-target-row__side chat-target-sidebar-loading__meta chat-target-sidebar-loading__meta--event">
                <SkeletonLine
                  className="event-list__time chat-target-row__time chat-target-sidebar-loading__time"
                  animated={animated}
                />
                <SkeletonPill className="chat-target-sidebar-loading__badge" animated={animated} />
              </div>
            )}
          />
        ) : (
          <li
            key={`${variant}-${index}`}
            className={joinClassNames(
              'chat-target-sidebar-loading',
              'chat-target-sidebar-loading--row',
              animated ? 'chat-target-sidebar-loading--animated' : '',
              itemClassName,
              className
            )}
            aria-hidden="true"
          >
            <SkeletonAvatar className="chat-target-sidebar-loading__avatar" animated={animated} />
            <span className="chat-target-sidebar-loading__body">
              <SkeletonLine
                className="chat-target-sidebar-loading__line chat-target-sidebar-loading__line--title"
                animated={animated}
              />
              <SkeletonLine
                className="chat-target-sidebar-loading__line chat-target-sidebar-loading__line--preview"
                animated={animated}
              />
            </span>
            <span className="chat-target-sidebar-loading__meta">
              <SkeletonLine className="chat-target-sidebar-loading__time" animated={animated} />
              <SkeletonPill className="chat-target-sidebar-loading__badge" animated={animated} />
            </span>
          </li>
        )
      ))}
      <li className="chat-target-sidebar-loading__status" role="status" aria-live="polite">
        <SkeletonIcon className="chat-target-sidebar-loading__statusDot" animated={animated} />
        <span className="chat-target-sidebar-loading__statusLabel">{label}</span>
      </li>
      {showLoadMore ? (
        <li className={joinClassNames('chat-target-sidebar-loading__loadMoreRow', loadMoreClassName)}>
          <button
            type="button"
            className={joinClassNames(
              'chat-target-sidebar-loading__loadMoreButton',
              loadMoreButtonClassName
            )}
            disabled
            aria-label={label}
            title={label}
          >
            {loadMoreLabel}
          </button>
        </li>
      ) : null}
    </>
  );
};

export default ChatTargetSidebarLoading;
